import React from 'react'
import { cn } from '@utils/safeTs'
import styles from './EditorChiudiEditorModal.module.sass'
import useTrans from '@hooks/useTrans'
import { Alert, Button, Modal } from '@components/atoms'


interface Props {
  open?: boolean
  onClose?: () => void
  onApply?: () => void
  className?: string
}

const EditorChiudiEditorModal = (props: Props) => {

  const { 
    open = false,
    onClose,
    onApply,
    className = '',
  } = props

  const t = useTrans()

  return (
    <Modal
      id={'editorchiudieditormodal'}
      open={open}
      onClose={onClose}
      title={t("Chiudi editor")}
      description={t("Sei sicuro di voler chiudere l'editor?")}
      buttons={(
        <>
          <Button variant="secondary" size="large" label={t("Annulla")} onClick={onClose} />
          <Button 
            variant='primary' 
            size="large" 
            label={t("Chiudi editor")} 
            onClick={onApply} 
          />
        </>
      )}
      className={cn(styles.root, className)}
      mainClassName={styles.main}
      headerClassName={styles.head}
      bodyClassName={styles.body}
    >
      <Alert 
        full
        variant='danger' 
        styleVariant='background' 
        placeholder={t("<strong>Attenzione!</strong> La chiusura dell'editor comporta la perdita delle configurazioni non ancora salvate.")}  
      />
    </Modal>
  )
}

export default EditorChiudiEditorModal
